import { render, staticRenderFns } from "./OrdersContainer.vue?vue&type=template&id=09cb3b69&"
import script from "./OrdersContainer.vue?vue&type=script&lang=js&"
export * from "./OrdersContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports